import { Link as MuiLink, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import type { FC } from 'react';
import type { To } from 'react-router-dom';

interface BreadcrumbProps {
  title: string | null;
  to?: To;
}
export const BREADCRUMB_TEST_ID = 'breadcrumb';

export const Breadcrumb: FC<BreadcrumbProps> = ({ title, to }) => {
  if (!to) {
    return (
      <Typography data-testid={BREADCRUMB_TEST_ID} variant="h6">
        {title}
      </Typography>
    );
  }

  return (
    <MuiLink
      sx={{ color: 'text.secondary' }}
      data-testid={BREADCRUMB_TEST_ID}
      underline="hover"
      to={to}
      component={Link}
    >
      {title}
    </MuiLink>
  );
};
